<template>
  <div class>
    <div class="notification-content">
      <p style="text-align: center; line-height: 27px">
        <strong
          ><span style="font-size: 21px; font-family: 仿宋"
            >告知书</span
          ></strong
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 28px; text-indent: 37px">
        <span style="font-size: 19px; font-family: 宋体; color: #727070"
          >&nbsp;</span
        ><span style="font-size: 19px; font-family: 仿宋"
          >欢迎访问祺信平台！祺信平台由南阳商祺数贸科技有限公司（以下简称“商祺数贸”）独立运营，向您提供祺信相关系统服务。对于您的隐私及权限，我们绝对尊重并予以保护，本告知书将告诉您，祺信平台（所涉域名为：https://pay.37cpep.com/，以下简称“平台”）收集与运用您的资料的方式以及我们的隐私保护政策。平台的告知书正在不断改进中，随着平台服务范围的扩大，我们会不定期更新我们的告知书内容。<br /> </span
        ><span style="font-size: 19px; font-family: 宋体">&nbsp;&nbsp;</span
        ><span style="font-size: 19px; font-family: 仿宋"
          >点击同意本《告知书》视为您已阅读并同意本告知书全部内容。本告知书的全部条款属于《用户服务协议》的一部分，相关名词定义参照《用户服务协议》。</span
        >
      </p>
      <p
        class="MsoListParagraph"
        style="margin-left: 28px; text-align: center; text-indent: 0"
      >
        <strong
          ><span style="font-size: 19px; font-family: 仿宋"
            >特别注意事项</span
          ></strong
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 28px; text-indent: 0">
        <span style="font-size: 19px; font-family: 宋体">&nbsp;&nbsp;</span
        ><span style="font-size: 19px; font-family: 仿宋"
          >您确认并承诺所获得的邀请码是通过合法合规的方式取得，且该取得不存在对任何第三方的违约或侵权等情形。</span
        >
      </p>
      <p class="MsoListParagraph" style="margin-left: 28px; text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >您在平台上的注册、信息录入、上传、修改、删除及确认、注销等操作行为代表公司，且您在平台上的操作已得到公司董事会或股东（大）会或其他有权机关的授权且不违反适用于公司的法律、法规、政策和公司章程的规定；若您违反公司章程和公司内部的其他规定而在平台进行操作，责任概由您及公司负责，与平台无关。</span
        >
      </p>
      <p style="text-align: center">
        <strong
          ><span style="font-size: 19px; font-family: 仿宋"
            >邀请码、用户名和密码</span
          ></strong
        >
      </p>
      <p>
        <span style="font-size: 19px; font-family: 宋体">&nbsp;&nbsp;</span
        ><span style="font-size: 19px; font-family: 仿宋"
          >当您作为被公司（委托人）指定的联系人，获取平台发送的邀请码，受委托人委托前来平台注册用户时，我们要求您设置委托人的平台登录用户名和密码。您可以通过该用户名和密码登录平台，并在委托人授权范围内进行后续操作。如果您丢失或泄露了上述邀请码、用户名和密码，您可能丢失了委托人的识别信息，并且可能出现对您及您所代表的公司不利的后果。因此，无论任何原因危及上述邀请码、用户名及密码安全，您应该立即通过平台公布的联系方式和我们取得联系，以便重置密码或重新发送邀请码。</span
        >
      </p>
      <p style="text-align: center">
        <strong
          ><span style="font-size: 19px; font-family: 仿宋"
            >注册与认证</span
          ></strong
        >
      </p>
      <p>
        <span style="font-size: 19px; font-family: 宋体">&nbsp;&nbsp;</span
        ><span style="font-size: 19px; font-family: 仿宋"
          >当您代表公司在平台完成注册，我们还会要求您代表公司提交公司身份认证信息和资料，包括但不限于：公司名称、公司证件类型、公司证件号、法定代表人真实姓名、法定代表人证件类型、法定代表人证件号码、操作员真实姓名、操作员的证件类型、操作员的证件号码、操作员的手机号码等信息。另外，您还应上传上述证照的原件或加盖公章的复印件的照片或扫描件，以及法定代表人对操作员注册和运营平台账户的授权委托书原件照片或扫描件，及操作员本人手持身份证的正面清晰照片，平台将在收到全部上述信息后的【1-3】个工作日内完成认证工作，并将认证结果展示在平台上予以通知。</span
        >
      </p>
      <p style="text-align: center">
        <strong
          ><span style="font-size: 19px; font-family: 仿宋"
            >用户行为</span
          ></strong
        >
      </p>
      <p>
        <span style="font-size: 19px; font-family: 宋体">&nbsp;&nbsp;</span
        ><span style="font-size: 19px; font-family: 仿宋"
          >为了提供并优化您需要的服务，我们会根据合理性、必要性原则收集用户使用服务的相关信息，这类信息包括：在用户使用平台服务访问网页时，自动接收并记录用户浏览器和计算机上的信息，包括用户的IP地址、浏览器的类型、访问日期和时间、软硬件特征信息及用户需求的网页记录等数据；如您下载或使用平台客户端软件，或访问移动网页使用平台服务时，我们可能会读取与您位置和移动设备相关的信息，包括设备型号、设备识别码、操作系统、分辨率、电信运营商等。</span
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >除上述信息外，我们还可能为了提供服务及改进服务质量的合理需要而收集用户的其他信息，包括用户与我们的客户服务团队联系时提供的相关信息，用户参与问卷调查时向我们发送的问卷答复信息。与此同时，为提高用户使用平台服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，我们可能会通过了解一些用户的网络使用习惯等手段来判断用户账户的风险。</span
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >我们保证将采取严格的保密措施保护用户的信息不被泄露，并仅将所搜集的信息用于上述目的。</span
        >
      </p>
      <p class="MsoListParagraph" style="text-align: center; text-indent: 37px">
        <strong
          ><span style="font-size: 19px; font-family: 仿宋"
            >Cookie</span
          ></strong
        ><strong
          ><span style="font-size: 19px; font-family: 仿宋"
            >的使用</span
          ></strong
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋">cookies</span
        ><span style="font-size: 19px; font-family: 仿宋"
          >是少量的数据，在用户未拒绝接受cookies的情况下，cookies将被发送到用户的浏览器，并储存在用户的计算机硬盘中。我们使用cookies储存用户访问我们平台的相关数据，在用户访问或再次访问我们的平台时，我们能识别用户的身份，并通过分析数据为您提供更好更多的服务。</span
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >用户有权选择接受或拒绝接受cookies。您可以通过修改浏览器的设置以拒绝接受cookies，但是我们需要提醒您，如您拒绝接受cookies，您可能无法使用依赖于cookies的我们网站的部分功能。</span
        >
      </p>
      <p style="text-align: center">
        <strong
          ><span style="font-size: 19px; font-family: 仿宋"
            >信息的披露和使用</span
          ></strong
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >我们不会向任何无关第三方提供、出售、出租、分享和交易用户信息，但为方便用户使用祺信、平台服务及平台关联公司或其他组织的服务（以下称“其他服务”），用户同意并授权平台将用户的信息传递给通用咨询、用户同时接受其他服务的平台和/或通用咨询关联公司或其他组织，或从为用户提供其他服务的平台和/或通用咨询关联公司或其他组织获取用户的信息，法律禁止的除外。如您及您的公司不同意该等信息共享，可向本公司发送书面声明，本公司将尊重您及您的公司的意愿及选择。</span
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >您同意我们可批露或使用您及（或）您的公司的用户信息以用于识别和（或）确认您的身份，或解决争议，或有助于确保网站安全、限制欺诈、非法或其他刑事犯罪活动，以执行我们的服务协议。</span
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >您同意我们可批露或使用您及（或）您的公司的用户信息以保护您的生命、财产之安全或为防止严重侵害他人之合法权益或为公共利益之需要。</span
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >您同意我们可批露或使用您及（或）您的公司的用户信息以改进我们的服务，并使我们的服务更能符合您的要求，从而使您在使用我们服务时得到更好的用户体验。</span
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >您同意我们利用您及（或）您的公司的用户信息与您联络，并向您提供您感兴趣的信息，如：服务到期提醒。</span
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >当我们被法律强制或依照政府或依权利人因识别涉嫌侵权行为人的要求而提供您的信息时，我们将善意地披露您的资料。</span
        >
      </p>
      <p class="MsoListParagraph" style="text-align: center; text-indent: 0">
        <strong
          ><span style="font-size: 19px; font-family: 仿宋"
            >信息的存储和交换</span
          ></strong
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >所收集的用户信息和资料将加密保存在平台及（或）其关联公司的服务器上。</span
        >
      </p>
      <p style="text-align: center">
        <strong
          ><span style="font-size: 19px; font-family: 仿宋"
            >外部链接</span
          ></strong
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >平台可能含有到其他网站的链接。我们对那些网站的隐私保护措施不负任何责任。我们可能在任何需要的时候增加商业伙伴或共用品牌的网站。</span
        >
      </p>
      <p style="text-align: center">
        <strong
          ><span style="font-size: 19px; font-family: 仿宋">安全</span></strong
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >我们平台有相应的安全措施来确保我们掌握的信息不丢失，不被滥用和篡改。这些安全措施包括向其它服务器备份数据和对用户信息加密。尽管我们有这些安全措施，但请注意，在因特网上不存在“绝对安全的安全措施”，鉴于网络安全技术的局限性、相对性以及危害网络安全事项及行为的不可预见性，用户信息仍有可能丢失、被滥用和篡改。</span
        >
      </p>
      <p style="text-align: center">
        <strong
          ><span style="font-size: 19px; font-family: 仿宋"
            >修改您的资料</span
          ></strong
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >您可以在平台上修改或者更新您的登录密码、交易密码、电话号码和电子邮件信息（在成功登录之后）。若需变更公司名称、地址、法定代表人、操作员信息时，我们需要您重新提交相应的证明文件的照片或扫描件，和授权委托书原件的照片或扫描件，及新的操作员本人手持身份证的正面清晰照片。</span
        >
      </p>
      <p style="text-align: center">
        <strong
          ><span style="font-size: 19px; font-family: 仿宋"
            >联系我们</span
          ></strong
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >如果您对本隐私声明或平台的隐私保护措施以及您在使用时有任何意见和建议，欢迎通过平台公布的联系方式向我们反馈意见。</span
        >
      </p>
      <p style="text-align: center">
        <strong
          ><span style="font-size: 19px; font-family: 仿宋"
            >法律声明</span
          ></strong
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >若要访问和使用平台服务，您需接受本告知书中所包含的条款、条件和平台即时刊登的通告，并且遵守有关互联网及/或本平台的相关法律、规定与规则；如您及您的委托人对此有异议，请在使用平台服务前与我们联系并签署书面的文件就条款变更予以确认。一旦您及您的委托人在未另行签署书面文件的情形下使用平台服务，即表示您及您的委托人同意并接受了所有该等条款、条件及通告。</span
        >
      </p>
      <p style="text-align: center">
        <strong
          ><span style="font-size: 19px; font-family: 仿宋"
            >版权和商标</span
          ></strong
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >平台所有的版权权利均在全世界范围内受到法律保护，除非有其他的标注或在相关条款和规则中被允许自由使用，本网站上可阅读和可见的所有资料都受到知识产权法的保护。</span
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >平台拥有的所有版权和商标未经书面同意，不得以任何非法手段侵犯。对于已经授权的版权或者商标用途，只能使用于授权时指定的范围。任何人不得利用工作之便获取版权和商标。</span
        >
      </p>
      <p style="text-align: center">
        <strong
          ><span style="font-size: 19px; font-family: 仿宋"
            >保密条款</span
          ></strong
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >任何人均需严格遵守安全保密条款，保护各方商业秘密及相关权益，包括但不限于产品知识产权、策划方案、客户资料、协议合同、技术文档、程序文件、程序控件或源代码、各种账户密码。任何人不得泄漏他人的任何商业秘密，同时不得利用工作之便获取他人技术秘密。对于授权使用的技术，只能使用于授权时指定的范围，不得用于它途。</span
        >
      </p>
      <p class="MsoListParagraph" style="text-indent: 37px">
        <span style="font-size: 19px; font-family: 仿宋"
          >我们补充承诺如下：当我们依权利人因识别涉嫌侵权行为人的要求而被要求提供您及（或）您的公司的信息时，我们将在不违反法律或监管强制要求的范围内向您及（或）您的公司发送事先通知；当您及（或）您的公司不同意提供相关信息时，在不违反法律或监管强制要求的前提下，我们将尽合理努力不向权利人披露您的资料。</span
        >
      </p>
      <p>
        <br />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  activated() {},
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/login/notification.vue